var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectivityCard = function SvgSelectivityCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 700 301"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 301,
    fill: "#EBEBEB",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M293.559 17.436c0-1.041-4.737-1.885-10.581-1.885s-10.581.844-10.581 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M293.559 17.436c0-1.041-4.737-1.885-10.581-1.885s-10.581.844-10.581 1.885"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 27.893,
    fill: "#DBDBDB",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 37.822,
    fill: "#DBDBDB",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 57.728,
    fill: "#DBDBDB",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.283,
    cy: 75.936,
    fill: "#DBDBDB",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 66.74,
    fill: "#DBDBDB",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.4,
    d: "M282.906 44.544c2.868 0 5.459.205 7.33.533.936.165 1.682.359 2.189.57q.381.159.554.31c.117.1.141.173.141.217 0 .043-.024.116-.141.217q-.173.151-.554.31c-.507.21-1.253.405-2.189.57-1.871.328-4.462.533-7.33.533s-5.461-.205-7.332-.534c-.936-.164-1.682-.358-2.189-.569a2.1 2.1 0 0 1-.554-.31c-.117-.101-.141-.174-.141-.217s.024-.116.141-.217q.173-.151.554-.31c.507-.211 1.253-.405 2.189-.57 1.871-.328 4.463-.533 7.332-.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M272.478 17.084v56.991M293.501 17.506v66.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "M293.542 27.569V17.48v17.105"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 0.5,
    d: "M293.542 20.349V17.48v4.864"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M293.459 28.107c0-1.04-4.715-1.884-10.531-1.884s-10.531.844-10.531 1.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "M293.459 38.037c0-1.04-4.715-1.885-10.531-1.885s-10.531.844-10.531 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M293.459 57.943c0-1.04-4.715-1.884-10.531-1.884s-10.531.843-10.531 1.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "M293.516 76.15c0-1.04-4.715-1.884-10.531-1.884s-10.531.843-10.531 1.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M293.459 66.955c0-1.04-4.715-1.885-10.531-1.885s-10.531.844-10.531 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "M293.349 27.997c.019-.127-.142-.44-.933-.684-.791-.243-1.996-.523-2.499-.633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5656",
    stroke: "#FF000F",
    strokeWidth: 0.5,
    d: "M272.579 49.164v-3.147c1.77-1.129 5.726-1.374 7.546-1.488l.057-.003c.911-.057 4.392-.287 7.968.198 2.856.387 4.747.95 5.323 1.293v3.092c0 .048-.069.074-.105.042-.339-.298-1.318-.813-3.319-1.137-2.848-.46-5.499-.504-10.07-.33-3.312.128-6.423.963-7.318 1.523-.035.022-.082-.002-.082-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    d: "M293.49 66.691c-.577-.354-1.777-1.242-7.279-1.578M272.524 37.875c.576-.354 1.776-1.242 7.278-1.578"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M293.641 46.199c-.576-.354-1.776-1.242-7.278-1.578"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 0.4,
    d: "M283.069 47.708c2.955 0 5.625.205 7.552.533.965.165 1.734.358 2.258.57.262.105.452.212.572.312.122.102.145.174.145.215 0 .04-.023.113-.145.215q-.18.151-.572.312c-.524.211-1.293.405-2.258.57-1.927.328-4.597.533-7.552.533s-5.625-.205-7.553-.533c-.965-.165-1.734-.359-2.257-.57a2.2 2.2 0 0 1-.573-.312c-.121-.102-.145-.174-.145-.215s.024-.113.145-.215q.18-.152.573-.312c.523-.212 1.292-.405 2.257-.57 1.928-.329 4.598-.533 7.553-.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "m309 34.1 15-6.1v215h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M11.244 255.634c96.51-.647 201.272-1.289 297.782-.762M342.314 255.588h38.035"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.5,
    d: "M342.88 255.588c14.953.044-2.248.002 19.862-.004"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M238.8 24.106v213.89M242.048 25.953V236.87M225.246 18.035v220.142"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "m42.28 1.45.836 256.114"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.2,
    d: "m41.619 1.45.837 256.114"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M339.159 107.389v130.66M427.35 37.656V259.5M1.497 255.032l221.083 8.227 36.471-8.54M257.643 243.492v24.942M233.512 24.71v242.782"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_svg__b)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 413.404 220.607)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_svg__c)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 396.461 225.723)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_svg__d)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 427.15 217.412)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_svg__e)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 437.379 230.838)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_svg__f)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 424.734 228.756)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.819,
    cy: 10.454,
    fill: "#BABABA",
    rx: 9.819,
    ry: 10.454,
    transform: "matrix(.74966 -.66182 .68622 .7274 433.87 238.336)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.819,
    cy: 10.454,
    fill: "url(#selectivity_card_svg__g)",
    rx: 9.819,
    ry: 10.454,
    transform: "matrix(.74966 -.66182 .68622 .7274 433.87 238.336)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.772,
    cy: 9.338,
    fill: "#BABABA",
    rx: 8.772,
    ry: 9.338,
    transform: "matrix(.74966 -.66182 .68622 .7274 443.383 246.354)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.772,
    cy: 9.338,
    fill: "url(#selectivity_card_svg__h)",
    rx: 8.772,
    ry: 9.338,
    transform: "matrix(.74966 -.66182 .68622 .7274 443.383 246.354)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 372.81 242.215)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_svg__i)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 372.81 242.215)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 302.196 242.252)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_svg__j)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 302.196 242.252)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 316.106 242.213)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_svg__k)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 316.106 242.213)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 314.353 229.783)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#selectivity_card_svg__l)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 314.353 229.783)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 319.611 233.305)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#selectivity_card_svg__m)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 319.611 233.305)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.892,
    cy: 13.363,
    fill: "#BABABA",
    rx: 12.892,
    ry: 13.363,
    transform: "matrix(.77894 -.6271 .6523 .75796 384.558 240.893)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.892,
    cy: 13.363,
    fill: "url(#selectivity_card_svg__n)",
    rx: 12.892,
    ry: 13.363,
    transform: "matrix(.77894 -.6271 .6523 .75796 384.558 240.893)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.867,
    cy: 11.264,
    fill: "#BABABA",
    rx: 10.867,
    ry: 11.264,
    transform: "matrix(.77894 -.6271 .6523 .75796 426.387 244.789)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.867,
    cy: 11.264,
    fill: "url(#selectivity_card_svg__o)",
    rx: 10.867,
    ry: 11.264,
    transform: "matrix(.77894 -.6271 .6523 .75796 426.387 244.789)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "#BABABA",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 396.982 236.037)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "url(#selectivity_card_svg__p)",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 396.982 236.037)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M316.699 94.473 112.537.215h-8.461l212.623 96.2z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.719 2.783-.074 10.417v4.82L42.72 7.553 298.55 103.86l4.331-.221z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA200",
    d: "M42.615 7.219-.176 14.853v4.819l42.791-7.683 255.832 96.307 4.331-.221z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC582",
    d: "M42.615 5.406-.176 13.04v4.82l42.791-7.683 255.832 96.306 4.331-.221z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "m.816 126.977 40.873-3.5 208.813 44.726M-.174 274.615l225.491-36.668h13.403l3.256-.871h7.565"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.5,
    d: "m42.93 123.773 12.06 1.618"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.6,
    d: "M238.793 206.629v48.049"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.8,
    d: "m-.019 127.065 20.909-1.817"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M238.78 237.791v-9.229"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 3,
    d: "M134.298 90.84v5.525a3 3 0 0 0 3 3h51.746a3 3 0 0 1 3 3v1.5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 3,
    d: "M129.892 90.84v5.525a3 3 0 0 1-3 3H75.147a3 3 0 0 0-3 3v1.5"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "m324.498 29.18 102.5 45.156v-.082l-102.5-44.57z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "m327.164 103.496 116.128 40.895M272.397 17.436c0-1.041 4.737-1.885 10.581-1.885s10.581.844 10.581 1.885m-21.162 0c0-1.041 4.737-1.885 10.581-1.885s10.581.844 10.581 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.3,
    d: "m411.331 84.917 34.339 15.294M262.663-41.684c0-1.04 4.738-1.884 10.581-1.884 5.844 0 10.581.843 10.581 1.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "m411.709 117.575 31.216 12.633M258.578-3.652c0-1.041 4.737-1.885 10.581-1.885s10.581.844 10.581 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "m377.841 166.791 65.45 22.595"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.5,
    d: "m433.19 185.957 10.158 3.551M378 166.727 401.914 175m25.586-41.5v5M247.782 167.51l30.663 7.143"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "m302.803 106.352 13.95 5.429"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__u)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.191,
    height: 80.234,
    x: 106.809,
    y: 11,
    fill: "#666",
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 50.191,
    height: 80.234,
    x: 106.809,
    y: 11,
    fill: "#666",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__v)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.601,
    height: 34.343,
    x: 110.153,
    y: 35.16,
    fill: "#666",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 113.483,
    cy: 39.282,
    r: 1.7,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.758,
    cy: 72.829,
    r: 1.7,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__w)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.048,
    height: 30.411,
    x: 116.153,
    y: 36.176,
    fill: "#666",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.848,
    height: 30.211,
    x: 116.253,
    y: 36.276,
    stroke: "#666",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M116.175 37.175a.3.3 0 0 1 .3-.3h30.213a.3.3 0 0 1 .3.3v2.977h-30.813z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.208,
    height: 16.662,
    x: 128.073,
    y: 42.766,
    fill: "#F9F9F9",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M117.2 69.777v2.555m0 6.67v-6.67m14.614-2.555v9.225m14.898-9.225v2.555m0 6.67v-6.67m-29.512 0h29.512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    d: "M155.491 20.016v8.604h-12.694v-8.604zm-13.194 0v8.604h-33.979v-8.604zm-21.005 8.487h.5v-8.469h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M108.381 21.336h47.346m-47.346.993h47.346m-47.346.992h47.346m-47.346.993h47.346m-47.346.992h47.346m-47.346.993h47.346m-47.346.993h47.346"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M107.128 79.289h49.871v.741h-49.871z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m116.153 40 4.394-.008 4.393-.007M139.358 40h7.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCDB2E",
    strokeWidth: 0.8,
    d: "M120.503 48.69h6.306"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M120.503 59.117h6.306"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    d: "M147.201 44h-2.435M116.175 44.055h3.638M147.201 59.115h-2.435M116.175 59.115h3.638"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    d: "M116.175 48.688h3.638M144.481 48.688h2.753"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 2,
    d: "M120.166 44h5.143000000000001M138.809 44h5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 0.8,
    d: "M138.809 48.69h5.009"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M138.809 59.115h5.5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__y)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.828,
    height: 7.102,
    x: 125.235,
    y: 38.514,
    fill: "#F9F9F9",
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 9.417,
    height: 1.82,
    x: 127.469,
    y: 39.805,
    fill: "#2A2A2A",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE5F02",
    d: "m331.92 59.955 25.599 11.52v25.01l-25.599-9.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9722",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m363.008 65.378.455 33.758-32.075-11.877-.486-36.058z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m363.16 65.729.451 33.408-32.223-11.879-.486-36.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE5F02",
    d: "m386.02 82.04 18.648 7.683v24.55l-18.648-5.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9722",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m409.435 85.496.418 30.974-24.129-8.989-.437-32.41z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m409.784 85.491.418 30.974-24.243-8.989-.437-32.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "m363.927 64.625 20.396 9.052.465 34.511-20.377-7.694z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.3,
    d: "m423.318 82.936.584 45.463M423.318 82.938l.584 45.463M411.22 78.522l.584 45.463"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.6,
    d: "m419.836 88.78 3.494 1.513v16.201"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.2,
    d: "m438.475 81.734 106.215 52.737M455.303 102.527l85.033 42.103"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "m452.567 88.653 66.511 32.897m-66.51-35.583 67.066 32.879M465.281 111.417l34.648 16.87m-34.648-20.863 34.648 17.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M483.05 59.81a1.83 1.83 0 0 1 3.66-.003l.281 158.583c.004 2.35-3.368 2.733-3.892.443a2 2 0 0 1-.049-.439z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.84,
    height: 4.571,
    x: 505.131,
    y: 112.574,
    fill: "#BABABA",
    rx: 2.286,
    transform: "rotate(-84.772 505.131 112.574)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.34,
    height: 4.071,
    x: 466.989,
    y: 108.75,
    fill: "#BABABA",
    stroke: "#BABABA",
    strokeWidth: 0.5,
    rx: 2.036,
    transform: "rotate(-84.772 466.989 108.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.84,
    height: 4.571,
    x: 462.853,
    y: 91.297,
    fill: "#BABABA",
    rx: 2.286,
    transform: "rotate(-84.772 462.853 91.297)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.34,
    height: 4.071,
    x: 494.612,
    y: 121.965,
    fill: "#BABABA",
    stroke: "#BABABA",
    strokeWidth: 0.5,
    rx: 2.036,
    transform: "rotate(-84.772 494.612 121.965)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.3,
    d: "M487 15v246"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.3,
    d: "M452.576 52.008v73.242M465.207 101.32l-.026 45.078M500.444 117.547l-.026 45.078M519.8 58.078v116.695"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "m452.813 85.988 11.992 5.9M480.419 102.297l2.797 1.336v10.457M508.019 108.035c.876.484 2.209 1.484 1.817 2.932-.448 1.65-1.845 1.649-2.376 1.733M469.606 104.438c.875.483 2.209 1.483 1.816 2.932-.447 1.649-1.844 1.648-2.375 1.732"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M33.66 182.101c0 3.402-1.975 6.159-4.411 6.159s-4.41-2.757-4.41-6.159 1.974-6.16 4.41-6.16 4.41 2.758 4.41 6.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m496.332 120.165 12.306-10.688m0 0c6.59 6.241 68.091 32.495 88.976-32.618m-88.976 32.618c6.59 6.241 84.062 18.161 104.947-46.952M467.491 107.515l-2.402-15.96c-.283-1.88 2.427-3.672 4.187-2.95 16.475 6.754 64.237 14.313 77.15-26.492"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m467.49 107.514-2.401-15.96c-.283-1.88 2.698-4.204 4.575-3.896 19.293 3.167 79.851-2.761 87.746-31.113"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M557.578 205.144v-5.58l38.035-.966 67.833 1.284v4.062l4.895 10.501-.3 15.428v2.155l-1.279.151v2.595l-2.233 4.456-1.083 7.776v6.438l.615 1.21 1.798 8.277h-3.549l-6.719-.871h-2.413l.331 2.275-4.732.58-7.286-1.064-23.209 3.215.455 2.637-5.762.465-6.823-1.252-4.094.399v2.869l-3.942.698-7.718-1.861v-2.105l-14.348-2.362-10.494-2.335h-3.294l-5.868-1.053 2.368-10.951-1.184-20.753h-3.133v-18.22z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m574.569 157.294-16.858 4.817v36.726l37.328-1.204 66.829 1.204v-34.92l-69.839-8.429z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M557.578 205.144v-5.58l38.035-.966 67.833 1.284v4.062l4.895 10.501-.3 15.428v2.155l-1.279.151v2.595l-2.233 4.456-1.083 7.776v6.438l.615 1.21 1.798 8.277h-3.549l-6.719-.871h-2.413l.331 2.275-4.732.58-7.286-1.064-23.209 3.215.455 2.637-5.762.465-6.823-1.252-4.094.399v2.869l-3.942.698-7.718-1.861v-2.105l-14.348-2.362-10.494-2.335h-3.294l-5.868-1.053 2.368-10.951-1.184-20.753h-3.133v-18.22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m583.368 234.392 14.026 1.246 71.51-4.163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#878585",
    d: "M564.726 200.045h1.903v25.945h-1.903z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M594.588 216.781h-8.727v15.631l8.727.752z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m656.859 216.389 3.369.207v13.586l-3.369-.305z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M660.29 216.637h5.854v13.391h-5.854z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.956,
    cy: 0.572,
    fill: "#666",
    rx: 0.956,
    ry: 0.572,
    transform: "matrix(-.6781 .73497 .6487 .76105 568.359 223.061)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.929,
    cy: 0.575,
    fill: "#666",
    rx: 0.929,
    ry: 0.575,
    transform: "matrix(-.7142 .69995 .61046 .79205 569.505 224.547)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m569.862 225.012-1.132-1.496-1.347 1.295 1.132 1.496z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__E)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.786,
    cy: 234.723,
    fill: "#BABABA",
    rx: 5.713,
    ry: 10.389
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M572.196 224.316h4.761v20.79h-4.761z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__F)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 572.107,
    cy: 234.723,
    fill: "#BABABA",
    rx: 5.713,
    ry: 10.389
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 572.7,
    cy: 233.458,
    fill: "#666",
    rx: 1.975,
    ry: 5.235
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M564.504 228.246h8.395v10.421h-8.395z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__G)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.131,
    cy: 233.516,
    fill: "#BABABA",
    rx: 5.476,
    ry: 8.76
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__H)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__I)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 565.266,
    cy: 227.43,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__J)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.309,
    cy: 226.457,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__K)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.372,
    cy: 225.859,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__L)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.361,
    cy: 225.736,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__M)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.351,
    cy: 226.131,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__N)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 560.45,
    cy: 226.945,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__O)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.764,
    cy: 227.863,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__P)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.061,
    cy: 229.123,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__Q)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.574,
    cy: 230.496,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__R)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.376,
    cy: 232.316,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__S)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.376,
    cy: 234.01,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__T)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.629,
    cy: 235.869,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__U)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.971,
    cy: 237.439,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__V)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.639,
    cy: 238.935,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__W)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 560.522,
    cy: 239.941,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__X)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.262,
    cy: 240.629,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__Y)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.164,
    cy: 241.187,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__Z)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.12,
    cy: 241.334,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aa)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.076,
    cy: 241.297,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ab)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.924,
    cy: 240.646,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ac)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 565.843,
    cy: 239.781,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ad)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.528,
    cy: 238.629,
    fill: "#BABABA",
    rx: 0.235,
    ry: 0.685
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ae)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.805,
    cy: 233.439,
    fill: "#BABABA",
    rx: 3.403,
    ry: 5.657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.956,
    cy: 0.572,
    fill: "#666",
    rx: 0.956,
    ry: 0.572,
    transform: "matrix(.6781 .73497 -.6487 .76105 578.433 223.225)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.929,
    cy: 0.575,
    fill: "#666",
    rx: 0.929,
    ry: 0.575,
    transform: "matrix(.7142 .69995 -.61046 .79205 577.287 224.717)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m576.93 225.178 1.132-1.496 1.347 1.295-1.132 1.496z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__af)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#selectivity_card_svg__ag)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M575.247 244.986v8.893a2 2 0 0 0 1.512 1.939l17.381 4.375c.236.059.48.075.721.047l68.26-8.007"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 600.045,
    y: 257.277,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 600.045 257.277)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 622.068,
    y: 254.498,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 622.068 254.498)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 639.436,
    y: 252.314,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 639.436 252.314)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 657.628,
    y: 250.02,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 657.628 250.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "m649.263 205.127 12.705-.254 4.253 9.268h-13.342zM648.448 205.174l-35.563-.301 4.072 10.51 35.438-1.094z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M612.718 204.897v-4.591c3.547-.336 4.748 1.337 4.868 2.179.097.673-.384 8.936-.625 12.9h-.465l.089-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A5A5",
    d: "M612.607 205.071v-4.592c3.31-.335 4.431 1.338 4.543 2.179.09.674-.359 8.937-.583 12.901z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 614.665,
    cy: 202.844,
    fill: "#333",
    rx: 0.638,
    ry: 0.875
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ai)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M653.438 202.925c.097.592-.384 7.862-.625 11.35h-.418l.042-.818-3.867-8.41v-3.89h-.111l.111-.15c3.547-.295 4.748 1.177 4.868 1.918"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A5A5",
    d: "M648.459 205.198v-4.04c3.31-.296 4.431 1.177 4.543 1.917.09.592-.378 7.7-.602 11.188z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 650.517,
    cy: 203.244,
    fill: "#333",
    rx: 0.638,
    ry: 0.77
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M612.542 204.863h-17.748l3.123 10.51h18.661z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.459,
    height: 5.79,
    x: 599.862,
    y: 216.979,
    fill: "#F5F5F5",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF000F",
    clipPath: "url(#selectivity_card_svg__aj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.999 221.709h.168c.503-.033.855-.547.855-1.16 0-.208-.034-.416-.109-.58h-.914zM604.915 219.969h-.838v1.751h.838zM605.862 219.859a1.06 1.06 0 0 0-.327-.361.87.87 0 0 0 .252-.624c0-.427-.26-.767-.587-.767h-.201v1.752zM604.915 218.107h-.838v1.752h.838zM607.262 221.719h.168c.503-.033.855-.547.855-1.16 0-.208-.034-.416-.109-.58h-.914zM607.178 219.969h-.838v1.751h.838zM608.125 219.859a1.05 1.05 0 0 0-.327-.361.87.87 0 0 0 .252-.624c0-.427-.26-.767-.587-.767h-.201v1.752zM607.178 218.107h-.838v1.752h.838zM601.538 219.969l-.478 1.751h.695l.202-.766h.444v-.985zM602.401 218.107h-.361l-.477 1.752h.838zM602.485 220.954h.444l.201.766h.696l-.478-1.751h-.863zM603.323 219.859l-.478-1.752h-.36v1.752z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ak)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#selectivity_card_svg__al)",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m581.419 241.564 13.743 12.522c.585.702 2.038.894 2.938.737l68.695-11.979"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 601.373,
    y: 246.555,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 601.373 246.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 623.57,
    y: 243.404,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 623.57 243.404)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 640.907,
    y: 240.906,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 640.907 240.906)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 659.69,
    y: 238.018,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 659.69 238.018)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__am)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.807,
    cy: 253.948,
    fill: "#BABABA",
    rx: 2.436,
    ry: 3.897
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__an)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.662,
    cy: 253.911,
    fill: "#BABABA",
    rx: 1.514,
    ry: 2.517
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m598.811 269.875.801 2.823c2.057-.361 2.442-1.581 2.363-2.118-.063-.429-1.775-5.431-2.601-7.829l-.263.074.213.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m598.719 269.785.8 2.823c1.924-.323 2.264-1.531 2.18-2.066-.066-.428-1.76-5.435-2.578-7.836z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.391,
    cy: 0.559,
    fill: "#333",
    rx: 0.391,
    ry: 0.559,
    transform: "scale(1 -1)rotate(15.834 1252.034 2017.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m596.368 270.045.801 2.823c2.057-.361 2.442-1.581 2.363-2.118-.063-.429-1.775-5.431-2.601-7.83l-.263.075.213.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m596.275 269.951.801 2.823c2.01-.347 2.38-1.564 2.3-2.1-.065-.428-1.77-5.432-2.594-7.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m558.365 260.957-.8 2.823c-2.057-.361-2.442-1.581-2.363-2.118.063-.429 1.774-5.431 2.601-7.829l.262.074-.212.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m558.458 260.867-.8 2.823c-1.924-.323-2.264-1.531-2.181-2.066.067-.428 1.761-5.435 2.578-7.836z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.945,
    cy: 255.516,
    fill: "#333",
    rx: 0.391,
    ry: 0.559,
    transform: "rotate(-164.166 558.945 255.516)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m560.809 261.129-.801 2.823c-2.056-.361-2.442-1.581-2.363-2.118.064-.429 1.775-5.431 2.602-7.83l.262.075-.212.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m560.902 261.039-.801 2.823c-2.01-.347-2.38-1.564-2.299-2.1.064-.428 1.769-5.433 2.593-7.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m616.298 267.113.958 2.773c2.033-.476 2.349-1.716 2.24-2.248-.087-.424-2.078-5.322-3.038-7.67l-.258.089.243.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m616.2 267.033.959 2.772c1.902-.43 2.174-1.655 2.06-2.185-.091-.423-2.064-5.327-3.015-7.678z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.391,
    cy: 0.559,
    fill: "#333",
    rx: 0.391,
    ry: 0.559,
    transform: "scale(1 -1)rotate(19.066 1087.71 1697.892)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m612.418 267.501.958 2.773c2.033-.475 2.349-1.716 2.24-2.247-.087-.425-2.078-5.323-3.038-7.671l-.258.089.243.545z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m612.32 267.418.958 2.772c1.988-.46 2.288-1.695 2.178-2.225-.089-.425-2.073-5.325-3.031-7.674z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m651.081 261.748.841 2.561c2.035-.46 2.397-1.613 2.309-2.104-.069-.393-1.85-4.914-2.71-7.082l-.259.085.22.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m650.987 261.672.841 2.561c1.903-.417 2.221-1.555 2.129-2.045-.073-.392-1.836-4.919-2.687-7.089z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.391,
    cy: 0.514,
    fill: "#333",
    rx: 0.391,
    ry: 0.514,
    transform: "scale(1 -1)rotate(18.176 1128.552 1900.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m647.218 262.143.841 2.561c2.035-.461 2.397-1.613 2.31-2.105-.07-.393-1.851-4.914-2.711-7.081l-.259.085.22.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m647.125 262.063.841 2.561c1.989-.446 2.336-1.593 2.247-2.084-.071-.393-1.846-4.916-2.703-7.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m663.226 260.722.693 2.442c1.724-.296 2.039-1.347 1.968-1.81-.056-.371-1.529-4.702-2.241-6.778l-.219.062.182.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m663.148 260.642.692 2.442c1.613-.264 1.89-1.304 1.816-1.767-.059-.37-1.518-4.705-2.222-6.783z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.327,
    cy: 0.484,
    fill: "#333",
    rx: 0.327,
    ry: 0.484,
    transform: "scale(1 -1)rotate(15.834 1252.547 2251.063)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m659.957 260.839.692 2.442c1.725-.296 2.039-1.347 1.969-1.81-.056-.371-1.53-4.702-2.241-6.778l-.22.062.183.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m659.878 260.755.693 2.442c1.685-.285 1.987-1.332 1.915-1.795-.057-.371-1.525-4.703-2.234-6.78zM574.569 157.294l-16.858 4.817v36.726l37.328-1.204 66.829 1.204v-34.92l-69.839-8.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m606.957 158.627 6.622 1.204.602 36.726h-7.224z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.006,
    cy: 162.801,
    fill: "#BABABA",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.051,
    cy: 162.782,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.452,
    cy: 160.736,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.754,
    cy: 160.736,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 612.808,
    cy: 162.105,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 612.808,
    cy: 163.261,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.733,
    cy: 164.865,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.575,
    cy: 164.865,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.293,
    cy: 163.261,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.232,
    cy: 162.105,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m614.182 160.045 6.622 1.162.603 35.451h-6.89z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 618.255,
    cy: 163.885,
    fill: "#BABABA",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 618.3,
    cy: 163.866,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.701,
    cy: 161.82,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.004,
    cy: 161.82,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.058,
    cy: 163.189,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.058,
    cy: 164.345,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 618.982,
    cy: 165.949,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.825,
    cy: 165.949,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 616.543,
    cy: 164.345,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 616.481,
    cy: 163.189,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m650.401 163.842 6.623 1.063.602 32.436h-7.225z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.474,
    cy: 167.683,
    fill: "#BABABA",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.52,
    cy: 167.665,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.92,
    cy: 165.619,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.223,
    cy: 165.619,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 166.986,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 168.144,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.202,
    cy: 169.748,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.044,
    cy: 169.748,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.762,
    cy: 168.144,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.7,
    cy: 166.986,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.474,
    cy: 192.637,
    fill: "#BABABA",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.52,
    cy: 192.618,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.92,
    cy: 190.572,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.223,
    cy: 190.572,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 191.939,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 193.097,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.202,
    cy: 194.701,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.044,
    cy: 194.701,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.762,
    cy: 193.097,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.7,
    cy: 191.939,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m643.048 162.658 6.623 1.097.481 33.569h-7.104z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.122,
    cy: 166.5,
    fill: "#BABABA",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.167,
    cy: 166.481,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.568,
    cy: 164.435,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.87,
    cy: 164.435,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 648.924,
    cy: 165.804,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 648.924,
    cy: 166.961,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.849,
    cy: 168.564,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.691,
    cy: 168.564,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.409,
    cy: 166.961,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.348,
    cy: 165.804,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.238,
    cy: 192.375,
    fill: "#BABABA",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.283,
    cy: 192.356,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.683,
    cy: 190.31,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.986,
    cy: 190.31,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.04,
    cy: 191.679,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.04,
    cy: 192.836,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.965,
    cy: 194.441,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.807,
    cy: 194.441,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.525,
    cy: 192.836,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.463,
    cy: 191.679,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m555.51 199.39 39.679-.951 69.054 1.186"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.312,
    cy: 9.652,
    fill: "#BABABA",
    rx: 9.312,
    ry: 9.652,
    transform: "matrix(.77894 -.6271 .6523 .75796 507.901 234.795)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.312,
    cy: 9.652,
    fill: "url(#selectivity_card_svg__ao)",
    rx: 9.312,
    ry: 9.652,
    transform: "matrix(.77894 -.6271 .6523 .75796 507.901 234.795)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.062 226.061)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_svg__ap)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.062 226.061)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 518.966 243.992)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#selectivity_card_svg__aq)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 518.966 243.992)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.973,
    cy: 19.666,
    fill: "#BABABA",
    rx: 18.973,
    ry: 19.666,
    transform: "matrix(.77894 -.6271 .6523 .75796 458.91 230.271)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.973,
    cy: 19.666,
    fill: "url(#selectivity_card_svg__ar)",
    rx: 18.973,
    ry: 19.666,
    transform: "matrix(.77894 -.6271 .6523 .75796 458.91 230.271)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M525.67 237.413c3.903 4.536 3.422 11.148-1.075 14.768s-11.307 2.879-15.211-1.657-3.423-11.148 1.074-14.769c4.498-3.621 11.308-2.878 15.212 1.658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#selectivity_card_svg__as)",
    d: "M525.67 237.413c3.903 4.536 3.422 11.148-1.075 14.768s-11.307 2.879-15.211-1.657-3.423-11.148 1.074-14.769c4.498-3.621 11.308-2.878 15.212 1.658"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 486.815 241.279)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_svg__at)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 486.815 241.279)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 3,
    d: "M193.912 172.5v23.969a6 6 0 0 0 6 6h337.774a6 6 0 0 1 6 6v14.373c0 1.657 1.341 3 2.998 3h7.874",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__au)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.256,
    cy: 180.834,
    fill: "#fff",
    rx: 44.337,
    ry: 40.014
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__av)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 586.59,
    cy: 167.276,
    fill: "#fff",
    rx: 46.59,
    ry: 42.276
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aw)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.59,
    cy: 231.276,
    fill: "#fff",
    rx: 46.59,
    ry: 42.276
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ax)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.954,
    cy: 230.653,
    fill: "#fff",
    rx: 14.892,
    ry: 42.276
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__ay)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 520.444,
    cy: 193.218,
    fill: "#fff",
    rx: 34.094,
    ry: 30.937
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__az)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_svg__aA)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 145,
    y: 104.055,
    fill: "#FF000F",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.245 107.555h5.836l-3.932 7.181 6.601-2.629-7.677 14.879 2.876-9.726-5.856 2.463z"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aC)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_svg__aD)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 82,
    y: 11,
    fill: "#00DD16",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.245 14.5h5.836l-3.932 7.18 6.601-2.627-7.677 14.879 2.876-9.727-5.856 2.463z"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aF)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_svg__aG)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 24,
    y: 104,
    fill: "#00DD16",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.245 107.5h5.836l-3.932 7.181 6.601-2.628-7.677 14.879 2.876-9.726-5.856 2.462z"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aI)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 3,
    d: "M71.5 172.5v24.625a6 6 0 0 1-6 6H25.965a6 6 0 0 1-6-5.999v-12.399a3 3 0 0 1 3-2.999h6.52"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    d: "m136.659 252.426 14.253-2.504M38.203 268.521l52.182-8.494M257.836 243.75v10.707h38.359"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aJ)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M316.765 235.374c0 23.349-20.86 42.277-46.591 42.277s-46.59-18.928-46.59-42.277 20.859-42.276 46.59-42.276 46.591 18.927 46.591 42.276"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aK)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M758.681 229.224c0 23.348-20.86 42.276-46.591 42.276s-46.59-18.928-46.59-42.276 20.859-42.277 46.59-42.277 46.591 18.928 46.591 42.277"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M50.473 105.855a2 2 0 0 1 2-2H91.41a2 2 0 0 1 2 2v64.637a2 2 0 0 1-2 2H52.473a2 2 0 0 1-2-2z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M170.965 105.859a2 2 0 0 1 2-2h38.937a2 2 0 0 1 2 2v64.637a2 2 0 0 1-2 2h-38.937a2 2 0 0 1-2-2z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 42.937,
    height: 68.637,
    x: 170.965,
    y: 103.859,
    fill: "#666",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aN)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.299,
    height: 29.379,
    x: 173.826,
    y: 124.527,
    fill: "#666",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 176.675,
    cy: 128.054,
    r: 1.455,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.91,
    cy: 156.751,
    r: 1.455,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aO)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.561,
    height: 26.016,
    x: 178.959,
    y: 125.396,
    fill: "#666",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.36,
    height: 25.816,
    x: 179.059,
    y: 125.496,
    stroke: "#666",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M178.978 126.294a.3.3 0 0 1 .3-.3h25.759a.3.3 0 0 1 .3.3v2.504h-26.359z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.022,
    height: 14.253,
    x: 189.156,
    y: 131.033,
    fill: "#F9F9F9",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M179.854 154.141v2.185m0 5.706v-5.706m12.502-2.185v7.891m12.745-7.891v2.185m0 5.706v-5.706m-25.247 0h25.247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    d: "M212.62 111.607v7.289h-10.788v-7.289zm-29.256 0v7.225h.5v-7.225h17.468v7.289h-28.996v-7.289z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M172.354 112.701h40.503m-40.503.849h40.503m-40.503.85h40.503m-40.503.849h40.503m-40.503.849h40.503m-40.503.849h40.503m-40.503.849h40.503"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M171.239 162.277h42.663v.634h-42.663z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m178.959 128.668 3.758-.006 3.759-.007M198.81 128.668h6.526999999999999"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCDB2E",
    strokeWidth: 0.8,
    d: "M182.68 136.1h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M182.68 145.021h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    d: "M205.519 132.09h-2.083M178.978 132.137h3.112M205.519 145.018h-2.083M178.978 145.018h3.112"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    d: "M178.978 136.1h3.112M203.193 136.1h2.354"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 2,
    d: "M182.391 132.09h4.4M198.34 132.09h4.705"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 0.8,
    d: "M198.34 136.1h2.352l1.933.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M198.34 145.018h4.705"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aQ)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.829,
    height: 6.011,
    x: 186.728,
    y: 140.086,
    fill: "#F9F9F9",
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8.055,
    height: 1.867,
    x: 188.639,
    y: 141.188,
    fill: "#2A2A2A",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.937,
    height: 68.637,
    x: 50.473,
    y: 103.855,
    fill: "#666",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aR)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.299,
    height: 29.379,
    x: 53.334,
    y: 124.523,
    fill: "#666",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 56.183,
    cy: 128.05,
    r: 1.455,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.418,
    cy: 156.747,
    r: 1.455,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aS)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.561,
    height: 26.016,
    x: 58.467,
    y: 125.393,
    fill: "#666",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.36,
    height: 25.816,
    x: 58.566,
    y: 125.493,
    stroke: "#666",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M58.486 126.29a.3.3 0 0 1 .3-.3h25.759a.3.3 0 0 1 .3.3v2.504h-26.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.022,
    height: 14.253,
    x: 68.664,
    y: 131.029,
    fill: "#F9F9F9",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M59.363 154.137v2.185m0 5.706v-5.706m12.501-2.185v7.891m12.745-7.891v2.185m0 5.706v-5.706m-25.246 0h25.246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    d: "M92.128 111.604v7.288H81.34v-7.288zm-29.256 0v7.224h.5v-7.224H80.84v7.288H51.844v-7.288z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M51.58 112.697h40.503m-40.502.849h40.502m-40.502.85h40.502m-40.502.849h40.502m-40.502.849h40.502m-40.502.849h40.502m-40.502.849h40.502"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M50.746 162.273h42.663v.634H50.746z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m58.467 128.664 3.758-.006 3.759-.007M78.318 128.664h6.526999999999999"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCDB2E",
    strokeWidth: 0.8,
    d: "M62.188 136.096h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M62.188 145.018h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    d: "M85.027 132.086h-2.083M58.486 132.133h3.112M85.027 145.014h-2.083M58.486 145.014h3.112"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    d: "M58.486 136.096h3.112M82.7 136.096h2.355"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 2,
    d: "M61.9 132.086h4.399M77.848 132.086h4.705"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 0.8,
    d: "M77.848 136.096H80.2l1.933.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M77.848 145.014h4.705"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_svg__aU)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.829,
    height: 5.762,
    x: 66.236,
    y: 127.395,
    fill: "#F9F9F9",
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8.055,
    height: 1.531,
    x: 68.147,
    y: 128.516,
    fill: "#2A2A2A",
    rx: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__q",
    width: 314.554,
    height: 112.676,
    x: -5.873,
    y: -3.017,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 2.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__r",
    width: 313.754,
    height: 111.876,
    x: -5.576,
    y: 1.819,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 2.7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__s",
    width: 72.146,
    height: 24.425,
    x: 127.098,
    y: 89.14,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__t",
    width: 72.146,
    height: 24.425,
    x: 64.947,
    y: 89.14,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__u",
    width: 61.591,
    height: 91.634,
    x: 101.109,
    y: 9.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__v",
    width: 51.601,
    height: 42.344,
    x: 106.153,
    y: 31.16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__w",
    width: 39.048,
    height: 38.412,
    x: 112.153,
    y: 36.176,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__x",
    width: 70.472,
    height: 21.34,
    x: 96.828,
    y: 72.989,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__y",
    width: 21.828,
    height: 15.102,
    x: 121.235,
    y: 38.514,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__z",
    width: 125.296,
    height: 85.685,
    x: 548.745,
    y: 196.898,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__A",
    width: 115.557,
    height: 54.75,
    x: 552.011,
    y: 153.788,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__B",
    width: 12.727,
    height: 20.383,
    x: 583.861,
    y: 214.781,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__C",
    width: 5.37,
    height: 15.793,
    x: 655.859,
    y: 216.389,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__D",
    width: 7.854,
    height: 15.391,
    x: 659.29,
    y: 216.637,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__E",
    width: 19.425,
    height: 28.777,
    x: 567.073,
    y: 221.334,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__F",
    width: 19.425,
    height: 28.777,
    x: 562.394,
    y: 221.334,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__G",
    width: 18.951,
    height: 25.52,
    x: 553.656,
    y: 221.756,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__H",
    width: 8.623,
    height: 20.969,
    x: 558.141,
    y: 225.051,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__I",
    width: 0.471,
    height: 5.371,
    x: 565.031,
    y: 226.744,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__J",
    width: 0.471,
    height: 5.371,
    x: 564.074,
    y: 225.771,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__K",
    width: 0.471,
    height: 5.371,
    x: 563.137,
    y: 225.174,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__L",
    width: 0.471,
    height: 5.371,
    x: 562.126,
    y: 225.051,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__M",
    width: 0.471,
    height: 5.371,
    x: 561.116,
    y: 225.445,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__N",
    width: 0.471,
    height: 5.371,
    x: 560.215,
    y: 226.26,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__O",
    width: 0.471,
    height: 5.371,
    x: 559.529,
    y: 227.178,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__P",
    width: 0.471,
    height: 5.371,
    x: 558.826,
    y: 228.438,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__Q",
    width: 0.471,
    height: 5.371,
    x: 558.339,
    y: 229.811,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__R",
    width: 0.471,
    height: 5.371,
    x: 558.141,
    y: 231.631,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__S",
    width: 0.471,
    height: 5.371,
    x: 558.141,
    y: 233.324,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__T",
    width: 0.471,
    height: 5.371,
    x: 558.394,
    y: 235.184,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__U",
    width: 0.471,
    height: 5.371,
    x: 558.736,
    y: 236.754,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__V",
    width: 0.471,
    height: 5.371,
    x: 559.404,
    y: 238.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__W",
    width: 0.471,
    height: 5.371,
    x: 560.287,
    y: 239.256,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__X",
    width: 0.471,
    height: 5.371,
    x: 561.026,
    y: 239.943,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__Y",
    width: 0.471,
    height: 5.371,
    x: 561.928,
    y: 240.502,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__Z",
    width: 0.471,
    height: 5.371,
    x: 562.885,
    y: 240.648,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aa",
    width: 0.471,
    height: 5.371,
    x: 563.84,
    y: 240.611,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ab",
    width: 0.471,
    height: 5.371,
    x: 564.688,
    y: 239.961,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ac",
    width: 0.471,
    height: 5.371,
    x: 565.608,
    y: 239.096,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ad",
    width: 0.471,
    height: 5.371,
    x: 566.293,
    y: 237.943,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ae",
    width: 6.806,
    height: 12.315,
    x: 559.402,
    y: 227.781,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__af",
    width: 93.374,
    height: 20.768,
    x: 573.497,
    y: 243.236,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ah",
    width: 12.992,
    height: 23.297,
    x: 608.607,
    y: 200.262,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ai",
    width: 12.992,
    height: 21.307,
    x: 644.459,
    y: 200.969,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ak",
    width: 90.875,
    height: 17.811,
    x: 577.419,
    y: 240.064,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__am",
    width: 12.872,
    height: 15.793,
    x: 587.371,
    y: 247.051,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__an",
    width: 3.028,
    height: 6.033,
    x: 592.148,
    y: 251.395,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4198_263858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__au",
    width: 219.673,
    height: 211.027,
    x: 458.419,
    y: 75.32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__av",
    width: 224.181,
    height: 215.553,
    x: 474.5,
    y: 59.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aw",
    width: 224.181,
    height: 215.553,
    x: 132.5,
    y: 123.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ax",
    width: 160.784,
    height: 215.553,
    x: 127.562,
    y: 122.877,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__ay",
    width: 199.188,
    height: 192.875,
    x: 420.85,
    y: 96.781,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__az",
    width: 55.8,
    height: 55.8,
    x: 129.1,
    y: 88.155,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.413846 0 0 0 0 0.0230772 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4198_263858",
    result: "effect2_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aB",
    width: 18.657,
    height: 27.432,
    x: 148.093,
    y: 103.555,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aC",
    width: 55.8,
    height: 55.8,
    x: 66.1,
    y: -4.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.413846 0 0 0 0 0.0230772 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4198_263858",
    result: "effect2_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aE",
    width: 18.657,
    height: 27.432,
    x: 85.093,
    y: 10.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aF",
    width: 55.8,
    height: 55.8,
    x: 8.1,
    y: 88.1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.413846 0 0 0 0 0.0230772 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4198_263858",
    result: "effect2_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aH",
    width: 18.657,
    height: 27.432,
    x: 27.093,
    y: 103.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aI",
    width: 65.934,
    height: 43.525,
    x: 12.765,
    y: 170.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aJ",
    width: 224.181,
    height: 215.553,
    x: 158.084,
    y: 127.598,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aK",
    width: 224.181,
    height: 215.553,
    x: 600,
    y: 121.447,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4198_263858",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aL",
    width: 54.337,
    height: 80.037,
    x: 44.773,
    y: 102.155,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aM",
    width: 54.337,
    height: 80.037,
    x: 165.265,
    y: 102.159,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aN",
    width: 45.299,
    height: 37.379,
    x: 169.826,
    y: 120.527,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aO",
    width: 34.56,
    height: 34.016,
    x: 174.959,
    y: 125.396,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aP",
    width: 63.263,
    height: 21.233,
    x: 160.939,
    y: 155.977,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aQ",
    width: 19.829,
    height: 14.012,
    x: 182.728,
    y: 140.086,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aR",
    width: 45.299,
    height: 37.379,
    x: 49.334,
    y: 120.523,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aS",
    width: 34.56,
    height: 34.016,
    x: 54.467,
    y: 125.393,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aT",
    width: 63.263,
    height: 21.233,
    x: 40.447,
    y: 155.973,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_svg__aU",
    width: 19.829,
    height: 13.762,
    x: 62.236,
    y: 127.395,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4198_263858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4198_263858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__b",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__c",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__d",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__e",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__f",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__g",
    x1: 9.819,
    x2: 9.819,
    y1: 0,
    y2: 20.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__h",
    x1: 8.772,
    x2: 8.772,
    y1: 0,
    y2: 18.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__i",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__j",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__k",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__l",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__m",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__n",
    x1: 12.892,
    x2: 12.892,
    y1: 0,
    y2: 26.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__o",
    x1: 10.867,
    x2: 10.867,
    y1: 0,
    y2: 22.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__p",
    x1: 18.473,
    x2: 18.473,
    y1: 0,
    y2: 38.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__ag",
    x1: 579.836,
    x2: 583.406,
    y1: 258.243,
    y2: 252.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__al",
    x1: 585.993,
    x2: 588.038,
    y1: 253.477,
    y2: 238.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__ao",
    x1: 9.312,
    x2: 9.312,
    y1: 0,
    y2: 19.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__ap",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__aq",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__ar",
    x1: 18.973,
    x2: 18.973,
    y1: 0,
    y2: 39.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__as",
    x1: 509.384,
    x2: 522.967,
    y1: 238.451,
    y2: 255.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_svg__at",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 301,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_svg__aj"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M601.06 218.107h7.225v3.612h-7.225z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_svg__aA"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 145,
    y: 104.055,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_svg__aD"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 82,
    y: 11,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_svg__aG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 24,
    y: 104,
    fill: "#fff",
    rx: 12
  })))));
};
export default SvgSelectivityCard;